import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useInvalidateThreadListQuery } from '../../../../api/hooks/useInvalidateThreadListQuery'
import { useRequestsStore } from '../../../../store/storeRequests'

const validationSchema = yup.object({
    name: yup
        .string()
        .matches(/[a-zA-Zа-яА-Я0-9,.;:?!№()-]/, 'Введите имя запроса')
        .required('Введите имя запроса'),
})

export const RequestRenameDialog = ({ open, handleClose, request }) => {
    const invalidateThreadListQuery = useInvalidateThreadListQuery()

    const { updateRequest } = useRequestsStore((state) => state)
    const { id: threadId, memory_message_count, name, agent } = request || {}

    const { values, errors, handleBlur, handleChange, handleSubmit, touched, isValid, dirty } =
        useFormik({
            initialValues: { name: name },
            validationSchema: validationSchema,
            onSubmit: async ({ name }) => {
                await updateRequest({ threadId }, { name, memory_message_count, agent })

                invalidateThreadListQuery()
                handleClose()
            },
        })

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '500px',
                    },
                }}
                open={open}
                onClose={handleClose}>
                <DialogTitle>Переименовать запрос</DialogTitle>

                <DialogContentText>
                    {/*Диалог будет удален без возможности восстановления*/}
                </DialogContentText>

                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            variant="outlined"
                            label="Название"
                            slotProps={{
                                htmlInput: {
                                    maxLength: 100,
                                },
                            }}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">
                            Отменить
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!(isValid && dirty)}>
                            Переименовать
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}
